import { SideNav } from "@/react/components/side-nav/SideNav";
import { Outlet } from "react-router-dom";
import React from "react";
import { SidebarProvider } from "@8x8/oxygen-sidebar-menu";
import { createPortal } from "react-dom";
import { routes } from "@/react/routing/router";

/**
 * Required Element for rendering the {@link https://reactrouter.com/en/main/start/tutorial#the-root-route|React Router Root}
 * The sidebar is also rendered here however, since we are running a hybrid app with Vue,
 * it's not mounted under React's DOM component tree but through a React Portal in the #sidebar element
 * defined in the root html {@link /public/index.html} file.
 *
 * This is done such that both React and Vue share the same sidebar
 * which is rendered and controller by the React app
 *
 *
 * @returns {Element}
 * @constructor
 */

export const Layout = () => {
  return (
    <>
      {createPortal(
        <SidebarProvider>
          <SideNav routes={routes} />
        </SidebarProvider>,
        document.getElementById("sidebar")
      )}
      <Outlet />
    </>
  );
};
